import createModel from 'utils/model'
import {getCorpTags} from 'services/corp-tags'

export default createModel({
    namespace: 'corpTags',

    state: {},

    effects: {
        // 获取企业标签列表
        *getCorpTags({payload, callback}, {call}) {
            const res = yield call(getCorpTags, payload)
            if (res && res.data) {
                callback && callback(res.data)
            }
        },
    },

    reducers: {},
})
